import { reduce } from "lodash"

import { Env } from "types/Env"

export function typifyEnv(env: Env<true>): Env {
  return reduce(
    env,
    (newEnv, value, key) => {
      if (value === "true" || value === "false") {
        // @ts-ignore
        newEnv[key] = value === "true"
      } else if (
        typeof value === "string" &&
        !Number.isNaN(value) &&
        !Number.isNaN(parseFloat(value))
      ) {
        // @ts-ignore
        newEnv[key] = parseFloat(value)
      } else {
        // @ts-ignore
        newEnv[key] = value
      }

      return newEnv
    },
    {} as Env,
  )
}
